import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {
    clearDataflowPublishingInfo,
} from "./actions";
import {MARGIN_MD, MODAL_WIDTH_MD, MODAL_WIDTH_XL, SPAN_FULL} from "../../../styles/constants";
import {Button, Col, Form, Input, Row} from "antd";
import {QUERY_HEIGHT} from "../dataset-builder/modals/components/utils";
import ZoomableHighlightedTextarea from "../../../components/zoomable-highlighted-textarea";
import EnhancedModal from "../../../components/enhanced-modal";

const mapStateToProps = state => {
    return {
        dataflowInfo: state.scenes.mappingHandler.dataflowPublishing.dataflowInfo,
    };
};

const mapDispatchToProps = dispatch => ({
    clearDataflowInfo: () => dispatch(clearDataflowPublishingInfo()),
});

const DataflowInfo = ({t, dataflowInfo, clearDataflowInfo}) => {
    return (
        <EnhancedModal
            visible={!!dataflowInfo}
            onCancel={clearDataflowInfo}
            width={MODAL_WIDTH_MD}
            title={t('scenes.dataManager.dataflowBuilder.modals.info.title', {id: dataflowInfo ? dataflowInfo.dataflowID : ""})}
            footer={<Button
                onClick={clearDataflowInfo}>{t('commons.buttons.close.title')}</Button>}
        >
            <Form>
                <Row style={{marginTop: MARGIN_MD}}>
                    <Col span={SPAN_FULL}>
                        <Form.Item
                            label={t('scenes.mappingHandler.DataflowPublishing.name')}
                        >
                            <Input value={dataflowInfo ? dataflowInfo.name : ""}
                                   title={dataflowInfo ? dataflowInfo.name : ""} disabled/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{marginTop: MARGIN_MD}}>
                    <Col span={SPAN_FULL}>
                        <Form.Item
                            label={t('scenes.mappingHandler.DataflowPublishing.query')}
                        >
                            <div style={{fontFamily: 'monospace', height: QUERY_HEIGHT}}>
                                <ZoomableHighlightedTextarea
                                    disabled
                                    value={dataflowInfo ? dataflowInfo.query : ""}
                                    modalProps={{bodyStyle: {height: "75vh"}, width: MODAL_WIDTH_XL}}
                                />
                            </div>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(DataflowInfo);